import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid} from 'react-bootstrap'; // import Tooltip here
import {Link} from 'react-router-dom';
import ReactModal from 'react-modal';

import {Label, SelectWithSearchAsync, Divider} from 'components/common';
import Input from 'form/input';
import Textarea from 'form/textarea';
import {Wrapper} from 'system/wrapper';
import {Modal, CloseModal, ModalContent} from 'components/modal';
import {LinkDefault, ButtonWrap, ButtonDefault} from 'components/buttons';

import {loadMedicalInstitutions, loadInstitutionDetail, submitInstitutionAccost, changeAccostValue, cleanAccostForm} from 'redux/actions/portal/institutions';

import close from 'images/general/close.svg';

const labelTitle = label => {
  switch (label) {
    case "gratitude":
      return "Залишити подяку";
    case "complaint":
      return "Залишити скаргу";
    case "accost":
      return "Залишити звернення"
    default:
  }
};

const modalFinish = finish => {
  switch (finish) {
    case "gratitude":
      return "Ваша подяка прийнята";
    case "complaint":
      return "Ваша скарга прийнята";
    case "accost":
      return "Ваше звернення прийняте"
    default:
  }
}

const modalPreview = preview => {
  switch (preview) {
    case "gratitude":
      return "Попередній перегляд подяки";
    case "complaint":
      return "Попередній перегляд скарги";
    case "accost":
      return "Попередній перегляд звернення"
    default:
  }
};

const modalButton = button => {
  switch (button) {
    case "gratitude":
      return "До подяки";
    case "complaint":
      return "До скарги";
    case "accost":
      return "До звернення";
    default:
  }
}

const modalText = text => {
  switch (text) {
    case "gratitude":
      return "Вашої подяки";
    case "complaint":
      return "Вашої скарги";
    case "accost":
      return "Вашого звернення";
    default:
  }
}

const mapStateToProps = state => ({
  token: state.auth.get('token'),
  institutions: state.institutions.get('institutionsList'),
  institution: state.institutions.get('institutionDetail'),
  accost: state.institutions.get('accost'),
  user: state.auth.get('user'),
  accostDetail: state.institutions.get('accostDetail')
});

const mapDispatchToProps = dispatch => ({
  loadInstitutions: search => dispatch(loadMedicalInstitutions('', search)),
  loadInstitutionDetail: (id) => dispatch(loadInstitutionDetail(id)),
  onChangeAccost: (value, key) => dispatch(changeAccostValue(value, key)),
  onSubmit: (event, institution_id, user_id, type) => {
    event.preventDefault()
    dispatch(submitInstitutionAccost(institution_id, user_id, type))
  },
  onClean: () => dispatch(cleanAccostForm())
});


class Reviews extends Component {

  constructor(props) {
    super(props);

    this.state = {
      institution: '',
      modalOpen: false,
      step1: true,
      step2: false,
      buttonDisabled: true,
      institutionSelect: ''
    }
    this.onToggleModal = this.onToggleModal.bind(this);
    this.onOpenStep1 = this.onOpenStep1.bind(this);
    this.onOpenStep2 = this.onOpenStep2.bind(this);
  }

  selectWithSearchStyle = {
    border: 'none'
  }

  onToggleModal() {
    this.setState({modalOpen: !this.state.modalOpen})
  }

  onOpenStep1() {
    this.setState({step1: true, step2: false})
  }

  onOpenStep2() {
    this.setState({step1: false, step2: true})
  }

  onChangeInstitutions = institution => {
    let institutionValue = institution ? institution.value : ''
    this.setState({
      institutionSelect: institution,
      institution: institutionValue
    });
  }

  generateInstitutionOptions = results => {
    return results.reduce((arr, item) => {
      const newOption = {value: item.get('id'), type: item.get('institution_type'), label: item.get('full_title') }
      arr.push(newOption)
      return arr
    }, [])
  }

  loadInstitutions = search => {
    if (!search) search=''
    return this.props.loadInstitutions(search)
      .then(response => {
        const results = response.get('results')
        if(!results.size) return Promise.resolve({ options: [] })
        const options = this.generateInstitutionOptions(results)
        return { options }
      })
  }

  componentWillUnmount() {
    this.props.onClean();
  }

  render() {

    return (
      <div>
        <Wrapper>
          <Grid>
            <h2>{labelTitle(this.props.match.params.type)}</h2>
            <Divider>
              <form onSubmit={(event) => this.props.onSubmit(event, this.state.institution, this.props.user.get('id'), this.props.match.params.type)}>
                <Label>Виберіть установу:<span style={{color: "#edbd2f"}}>*</span></Label>
                <SelectWithSearchAsync
                  searchable={true}
                  isSearchable={true}
                  value={this.state.institutionSelect}
                  loadOptions={this.loadInstitutions}
                  valueKey={'value'}
                  labelkey={'label'}
                  onChange={this.onChangeInstitutions}
                  style={ this.selectWithSearchStyle }
                  placeholder="Почніть вводити дя пошуку..."
                />
                <Input
                  block
                  label="Короткий опис:"
                  required
                  max="512"
                  value={this.props.accost.get('brief_description') ? this.props.accost.get('brief_description') : ""}
                  onChange={(event) => this.props.onChangeAccost(event.target.value, 'brief_description')}
                  placeholder="Введіть короткий опис"
                />
                <Textarea
                  block
                  required
                  label="Детальний опис:"
                  value={this.props.accost.get('detail_description') ? this.props.accost.get('detail_description') : ""}
                  onChange={(event) => this.props.onChangeAccost(event.target.value, 'detail_description')}
                  placeholder="Введіть детальний опис"
                />
           
                   <ButtonDefault
                  value="Попередній перегляд"
                  onClick={() => {
                    this.props.loadInstitutionDetail(this.state.institution)
                    this.onToggleModal()
                  }}
                />
               
              </form>
            </Divider>
          </Grid>
        </Wrapper>

        <ReactModal isOpen={this.state.modalOpen} onRequestClose={() => {
          this.onToggleModal()
        }}
          className={{
            base: 'modalContent',
            afterOpen: 'myClass_after-open',
            beforeClose: 'myClass_before-close'
          }} contentLabel="Підтвердження запису"
          overlayClassName={{
            base: 'modalOverlay',
            afterOpen: 'myOverlayClass_after-open',
            beforeClose: 'myOverlayClass_before-close'
          }}>

          <Modal>
            <CloseModal>
              <div onClick={(event) => {
                this.onToggleModal()
              }}>
                 <img src={close} alt="закрити" />
              </div>
            </CloseModal>
              <div>
              {this.state.step1 &&
                <ModalContent>
                  {this.state.institution === "" || this.props.accost.get('brief_description') === "" || this.props.accost.get('detail_description') === "" ? (
                      <h3>Спершу оберіть установу і заповніть усі поля</h3>
                  ): (
                    <div>
                    <h3>{modalPreview(this.props.match.params.type)}</h3>

                  {this.props.institution && 
                  <Divider>
                    <div>Установа: <strong>{this.props.institution.get('full_title')}</strong></div>
                  </Divider>
                  }
                  <Divider>
                    <div>Короткий опис: <strong>{this.props.accost.get('brief_description')}</strong></div>
                  </Divider>
                  <Divider>
                    <div>Детальний опис: <strong style={{whiteSpace: "pre-wrap"}}>{this.props.accost.get('detail_description')}</strong></div>
                  </Divider>
                  </div>
                  )}


                   {this.state.institution === "" || this.props.accost.get('brief_description') === "" || this.props.accost.get('detail_description') === "" ? (
                      null
                   ):(
                    <ButtonWrap>
                    <ButtonDefault onClick={(event) => {
                      this.props.onSubmit(event, this.state.institution, this.props.user.get('id'), this.props.match.params.type)
                      this.onOpenStep2()
                      this.props.onClean()
                    }} value="Відправити" />
                    <ButtonDefault  value="Скасувати" onClick={(event) => {
                      this.onToggleModal()
                      this.onOpenStep1()
                    }}/>
                     </ButtonWrap>
                   )}
                   </ModalContent>
                
              }
              {this.state.step2 &&
                <ModalContent>
                  <h3>{modalFinish(this.props.match.params.type)}</h3>
                  <Divider>
                    <h4>Дякуємо за те, що намагаєтесь зробити нас кращими!</h4>
                  </Divider>
                  <Divider>
                    <h4>Переглянути стан {modalText(this.props.match.params.type)} можна за цим <Link style={{color: "#edbd2f"}} to={this.props.accostDetail === undefined ? `/`:  `/cabinet/reviews/detail/${this.props.accostDetail.get('id')}`}>посиланням</Link></h4>
                  </Divider>
                  <ButtonWrap>
                    <LinkDefault to={this.props.accostDetail === undefined ? `/`:  `/cabinet/reviews/detail/${this.props.accostDetail.get('id')}`}>{modalButton(this.props.match.params.type)}</LinkDefault>
                    <ButtonDefault onClick={() => {
                      this.onToggleModal()
                      this.onOpenStep1()
                      this.props.onClean()
                    }} value="До порталу" />
                  </ButtonWrap>
                </ModalContent>
              }
              </div>
          </Modal>
        </ReactModal>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Reviews);



// WEBPACK FOOTER //
// ./src/system/main/reviews/index.js